module.exports = __webpack_public_path__ + "img/44.b90db456.jpg";